import { Button } from 'antd';
import React from 'react';

interface IColorBox {
    color: string;
}

const ColorBox: React.FC<IColorBox> = ({ color }) => {
    const boxStyle = {
        maxWidth: '50px',
        height: '30px',
        backgroundColor: color,
        border: '1px solid #08172a2f',
        cursor: 'default',
    };

    return <Button style={boxStyle} type={'text'} />;
};

export default ColorBox;
